/** 그램을 kg 로 보여 준다. 소수 둘째 자리까지. */
export function formatWeight(grams: number | null): string {
  if (grams === null) return "—"
  return `${(grams / 1000).toFixed(2)}kg`
}

export function formatJpy(value: number | null): string {
  if (value === null) return "—"
  return `¥${value.toLocaleString("ja-JP")}`
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, "0")
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}`
}

export function nullable(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—"
  return String(value)
}
